import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Menu, X, LogOut, LayoutDashboard } from 'lucide-react';
import { useState } from 'react';

export const Navbar = ({ user, setUser }) => {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    if (setUser) setUser(null);
    navigate('/');
  };

  return (
    <nav className="sticky top-0 z-50 backdrop-blur-md bg-[#0A0E1A]/80 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <div className="text-2xl font-bold tracking-tighter uppercase">
              <span className="text-[#00A6E8]">FALLOU</span>
              <span className="text-[#FFA726] ml-2">ENTERPRISE</span>
            </div>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-6">
            {!user ? (
              <>
                <Link to="/" className="text-slate-300 hover:text-white transition-colors">Home</Link>
                <Link to="/about" className="text-slate-300 hover:text-white transition-colors">About</Link>
                <Link to="/services" className="text-slate-300 hover:text-white transition-colors">Services</Link>
                <Link to="/contact" className="text-slate-300 hover:text-white transition-colors">Contact</Link>
                <Link to="/login">
                  <Button variant="outline" className="border-[#00A6E8] text-[#00A6E8] hover:bg-[#00A6E8]/10" data-testid="nav-login-btn">
                    Client Login
                  </Button>
                </Link>
              </>
            ) : (
              <>
                <Link to="/dashboard" className="text-slate-300 hover:text-white transition-colors flex items-center gap-2">
                  <LayoutDashboard size={18} />
                  Dashboard
                </Link>
                <Link to="/my-shipments" className="text-slate-300 hover:text-white transition-colors">My Shipments</Link>
                {user.is_admin && (
                  <Link to="/admin" className="text-[#FFA726] hover:text-[#FFB74D] transition-colors">Admin Panel</Link>
                )}
                <Button onClick={handleLogout} variant="ghost" className="text-slate-300 hover:text-white" data-testid="logout-btn">
                  <LogOut size={18} className="mr-2" />
                  Logout
                </Button>
              </>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 flex flex-col gap-4" data-testid="mobile-menu">
            {!user ? (
              <>
                <Link to="/" className="text-slate-300 hover:text-white transition-colors">Home</Link>
                <Link to="/about" className="text-slate-300 hover:text-white transition-colors">About</Link>
                <Link to="/services" className="text-slate-300 hover:text-white transition-colors">Services</Link>
                <Link to="/contact" className="text-slate-300 hover:text-white transition-colors">Contact</Link>
                <Link to="/login">
                  <Button variant="outline" className="border-[#00A6E8] text-[#00A6E8] w-full">Client Login</Button>
                </Link>
              </>
            ) : (
              <>
                <Link to="/dashboard" className="text-slate-300 hover:text-white transition-colors">Dashboard</Link>
                <Link to="/my-shipments" className="text-slate-300 hover:text-white transition-colors">My Shipments</Link>
                {user.is_admin && (
                  <Link to="/admin" className="text-[#FFA726] hover:text-[#FFB74D] transition-colors">Admin Panel</Link>
                )}
                <Button onClick={handleLogout} variant="ghost" className="text-slate-300 hover:text-white w-full justify-start">
                  <LogOut size={18} className="mr-2" />
                  Logout
                </Button>
              </>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};